import { Component } from '@angular/core';
import {HeroImagenesComponent} from "./all-imagenes/hero-imagenes/hero-imagenes.component";
import {InfoImagenesComponent} from "./all-imagenes/info-imagenes/info-imagenes.component";
import {FooterPersonaComponent} from "../footer-persona/footer-persona.component";
import {NavBarComponent} from "../nav-bar/nav-bar.component";
import {AllImagenesComponent} from "./all-imagenes/all-imagenes.component";

@Component({
  selector: 'app-imagenes',
  standalone: true,
  imports: [
    HeroImagenesComponent,
    InfoImagenesComponent,
    FooterPersonaComponent,
    NavBarComponent,
    AllImagenesComponent
  ],
  templateUrl: './imagenes.component.html',
  styleUrl: './imagenes.component.css'
})
export class ImagenesComponent {

}
